module.exports = __webpack_public_path__ + "static/media/afyon_texture_placeholder.a12917e5.png";